import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  FaUser, FaLock, FaBell, FaPalette, FaLanguage, FaShieldAlt, FaUserCog,
  FaCheck, FaChevronRight, FaSignOutAlt, FaEye, FaEyeSlash, FaSave,
  FaHeadset, FaFileAlt, FaQuestionCircle, FaHeart,FaChevronDown,
} from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const Settings = () => {
   const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('security'); // ✅ Default changed to 'security'

  const [loading, setLoading] = useState(false);

  // ✅ KEPT - Dark Mode (for appearance if needed later)
  // const [darkMode, setDarkMode] = useState(false);
const [openFaq, setOpenFaq] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const [passwordData, setPasswordData] = useState({
    current: '',
    new: '',
    confirm: ''
  });

  /* ✅ COMMENTED OUT - Notifications State (Future Use)
  const [notifications, setNotifications] = useState({
    email: false,
    push: false,
    sms: false,
    marketing: false
  });
  */

  /* ✅ COMMENTED OUT - Privacy State (Future Use)
  const [privacy, setPrivacy] = useState({
    profileVisibility: 'public',
    showEmail: false,
    showPhone: false,
    showLocation: false
  });
  */

  /* ✅ COMMENTED OUT - Profile Data State (Future Use)
  const [profileData, setProfileData] = useState({
    name: '',
    email: '',
    phone: '',
    location: '',
    dob: '',
    gender: '',
    bio: ''
  });
  */

  // useEffect(() => {
  //   fetchSettings();
  // }, []);

  // const fetchSettings = async () => {
  //   try {
  //     setLoading(true);

  //     const token = localStorage.getItem("token");

  //     const res = await axios.get(
  //       "http://localhost:5000/api/user/settings",
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`
  //         }
  //       }
  //     );

  //     const data = res.data;

      /* ✅ COMMENTED OUT - Profile Data Fetch (Future Use)
      setProfileData({
        name: data.name || '',
        email: data.email || '',
        phone: data.phone || '',
        location: data.location || '',
        dob: data.dob || '',
        gender: data.gender || '',
        bio: data.bio || ''
      });
      */

      /* ✅ COMMENTED OUT - Notifications Fetch (Future Use)
      setNotifications(
        data.notifications || {}
      );
      */

      /* ✅ COMMENTED OUT - Privacy Fetch (Future Use)
      setPrivacy(
        data.privacy || {}
      );
      */

  //   } catch (err) {
  //     console.log(err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  /* ✅ COMMENTED OUT - Save Profile (Future Use)
  const saveProfile = async () => {
    try {
      const token = localStorage.getItem("token");
      await axios.put(
        "http://localhost:5000/api/user/settings/profile",
        profileData,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      alert("Profile updated successfully");
    } catch (err) {
      console.log(err);
      alert("Update failed");
    }
  };
  */

  /* ✅ COMMENTED OUT - Save Notifications (Future Use)
  const saveNotifications = async () => {
    try {
      const token = localStorage.getItem("token");
      await axios.put(
        "http://localhost:5000/api/user/settings/notifications",
        notifications,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      alert("Notifications updated");
    } catch (err) {
      console.log(err);
    }
  };
  */

  /* ✅ COMMENTED OUT - Save Privacy (Future Use)
  const savePrivacy = async () => {
    try {
      const token = localStorage.getItem("token");
      await axios.put(
        "http://localhost:5000/api/user/settings/privacy",
        privacy,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      alert("Privacy updated");
    } catch (err) {
      console.log(err);
    }
  };
  */

  const updatePassword = async () => {

    // ✅ Validation
    if (!passwordData.current.trim()) {
      return alert("Please enter current password");
    }

    if (!passwordData.new.trim()) {
      return alert("Please enter new password");
    }

    if (passwordData.new.length < 6) {
      return alert("New password must be at least 6 characters");
    }

    if (passwordData.new !== passwordData.confirm) {
      return alert("New passwords do not match");
    }

    try {
      // ✅ Token localStorage से लो
      // आपके system में 'access_token' या 'token' check करो
      const token = localStorage.getItem("access_token") 
                 || localStorage.getItem("token")
                 || localStorage.getItem("user_token");

      if (!token) {
        return alert("Session expired. Please login again.");
      }

      console.log("🔄 Changing password...");

      const response = await axios.put(
        // ✅ सही URL - Django default port 8000
        "http://localhost:8000/api/change-password/",
        {
          currentPassword: passwordData.current,
          newPassword: passwordData.new
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      console.log("✅ Password changed:", response.data);

      // ✅ Success - fields clear karo
      alert("✅ Password updated successfully!");
      setPasswordData({ current: '', new: '', confirm: '' });
      setShowPassword(false);

    } catch (err) {
      console.error("❌ Password change error:", err);

      // ✅ Backend error message show karo
      if (err.response) {
        const errorMsg = err.response.data?.error 
                      || err.response.data?.detail
                      || "Failed to update password";

        if (err.response.status === 401) {
          alert("Session expired. Please login again.");
        } else if (err.response.status === 400) {
          alert(errorMsg); // "Current password is incorrect" etc.
        } else {
          alert("Server error. Please try again.");
        }
      } else if (err.request) {
        alert("Cannot connect to server. Check if server is running.");
      } else {
        alert("Something went wrong. Please try again.");
      }
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  // ✅ ONLY ACTIVE TABS - Security, Support, Logout
  const sidebarItems = [
    /* ✅ COMMENTED OUT (Future Use)
    { id: 'profile', icon: FaUser, label: 'Profile', badge: null },
    { id: 'account', icon: FaUserCog, label: 'Account', badge: null },
    */
    { id: 'security', icon: FaLock, label: 'Security', badge: null },
    /* ✅ COMMENTED OUT (Future Use)
    { id: 'notifications', icon: FaBell, label: 'Notifications', badge: '3' },
    { id: 'privacy', icon: FaShieldAlt, label: 'Privacy', badge: null },
    { id: 'appearance', icon: FaPalette, label: 'Appearance', badge: null },
    { id: 'language', icon: FaLanguage, label: 'Language', badge: null },
    */
    { id: 'support', icon: FaHeadset, label: 'Support', badge: null },
    { id: 'logout', icon: FaSignOutAlt, label: 'Logout', badge: null }
  ];

  // Toggle component (kept for future use)
  const Toggle = ({ value, onClick, label, description }) => (
    <div className="st-toggle-row">
      <div>
        <p className="st-toggle-label">{label}</p>
        <p className="st-toggle-desc">{description}</p>
      </div>
      <button className={`st-toggle-btn ${value ? 'on' : 'off'}`} onClick={onClick}>
        <span className={`st-toggle-knob ${value ? 'on' : 'off'}`}></span>
      </button>
    </div>
  );

   const faqData = [
    {
      id: 1,
      question: "How do I update my profile information?",
      answer: "Go to your Profile section from the dashboard. Click on 'Edit Profile' to update your personal details, photos, and preferences. Make sure to save changes after editing."
    },
    {
      id: 2,
      question: "How do I change my password?",
      answer: "Go to Settings → Security tab. Enter your current password, then enter your new password twice to confirm. Click 'Update Password' to save changes."
    },
    {
      id: 3,
      question: "How do I view someone's contact details?",
      answer: "You need an active premium membership to view contact details. Go to Plans & Pricing, choose a plan, and complete the payment. After that you can view contact details of profiles."
    },
    {
      id: 4,
      question: "How do I send interest to someone?",
      answer: "Open any profile you like and click the 'Send Interest' button. The person will receive a notification. If they accept, you'll be able to chat and connect."
    },
    {
      id: 5,
      question: "What is the referral program?",
      answer: "You can refer friends using your unique referral code. When someone registers using your code and makes a payment, you earn commission in your wallet. Check the Referral section for details."
    },
    {
      id: 6,
      question: "How do I delete my account?",
      answer: "To delete your account, please contact our support team at communityrishtey@gmail.com or call +91-8962813719. Our team will process your request within 24-48 hours."
    },
    {
      id: 7,
      question: "Is my personal information safe?",
      answer: "Yes, we take your privacy very seriously. Your personal information is encrypted and stored securely. We never share your data with third parties without your consent. Read our Privacy Policy for more details."
    },
  ];

  const renderContent = () => {
    switch (activeTab) {

      /* ✅ COMMENTED OUT - Profile Tab (Future Use)
      case 'profile':
        return (
          <>
            <h3 className="st-title">Profile Settings</h3>
            <p className="st-subtitle">Update your personal information</p>

            <div className="st-form-group">
              <label className="st-label">Full Name</label>
              <input
                type="text"
                className="st-input"
                value={profileData.name}
                onChange={(e) => setProfileData({ ...profileData, name: e.target.value })}
              />
            </div>

            <div className="st-form-row">
              <div className="st-form-group">
                <label className="st-label">Email</label>
                <input type="email" className="st-input" value={profileData.email} 
                  onChange={(e) => setProfileData({ ...profileData, email: e.target.value })} />
              </div>
              <div className="st-form-group">
                <label className="st-label">Phone</label>
                <input type="text" className="st-input" value={profileData.phone} 
                  onChange={(e) => setProfileData({ ...profileData, phone: e.target.value })} />
              </div>
            </div>

            <div className="st-form-row">
              <div className="st-form-group">
                <label className="st-label">Date of Birth</label>
                <input type="text" className="st-input" value={profileData.dob} 
                  onChange={(e) => setProfileData({ ...profileData, dob: e.target.value })} />
              </div>
              <div className="st-form-group">
                <label className="st-label">Gender</label>
                <select className="st-input" value={profileData.gender} 
                  onChange={(e) => setProfileData({ ...profileData, gender: e.target.value })}>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
              </div>
            </div>

            <div className="st-form-group">
              <label className="st-label">Location</label>
              <input type="text" className="st-input" value={profileData.location} 
                onChange={(e) => setProfileData({ ...profileData, location: e.target.value })} />
            </div>

            <div className="st-form-group">
              <label className="st-label">Bio</label>
              <textarea className="st-input st-textarea" value={profileData.bio} 
                onChange={(e) => setProfileData({ ...profileData, bio: e.target.value })} 
                placeholder="Tell us about yourself..." />
            </div>

            <button className="st-save-btn" onClick={saveProfile}>
              <FaSave size={13} /> Save Changes
            </button>
          </>
        );
      */

      /* ✅ COMMENTED OUT - Account Tab (Future Use)
      case 'account':
        return (
          <>
            <h3 className="st-title">Account Settings</h3>
            <p className="st-subtitle">Manage your account preferences</p>

            <Toggle value={true} onClick={() => { }} label="Two-Factor Authentication" 
              description="Add an extra layer of security to your account" />
            <Toggle value={true} onClick={() => { }} label="Account Verification" 
              description="Get verified badge on your profile" />
            <Toggle value={false} onClick={() => { }} label="Auto-Renew Membership" 
              description="Automatically renew your premium membership" />

            <div style={{ marginTop: 20 }}>
              <h4 className="st-sub-title">Account Information</h4>
              <div className="st-info-grid">
                <div className="st-info-item">
                  <p className="st-info-label">Member Since</p>
                  <p className="st-info-value">25 June 2025</p>
                </div>
                <div className="st-info-item">
                  <p className="st-info-label">Account Status</p>
                  <p className="st-info-value" style={{ color: '#4caf50' }}>Active</p>
                </div>
                <div className="st-info-item">
                  <p className="st-info-label">Membership</p>
                  <p className="st-info-value">Premium</p>
                </div>
                <div className="st-info-item">
                  <p className="st-info-label">Last Login</p>
                  <p className="st-info-value">2 mins ago</p>
                </div>
              </div>
            </div>
          </>
        );
      */

      // ✅ ACTIVE - Security Tab
      case 'security':
        return (
          <>
            <h3 className="st-title">Security Settings</h3>
            <p className="st-subtitle">Change your password and security preferences</p>

            <div className="st-form-group">
              <label className="st-label">Current Password</label>
              <div style={{ position: 'relative' }}>
                <input
                  type={showPassword ? 'text' : 'password'}
                  className="st-input"
                  value={passwordData.current}
                  onChange={(e) => setPasswordData({ ...passwordData, current: e.target.value })}
                  placeholder="Enter current password"
                />
                <button
                  type="button"
                  className="st-eye-btn"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash size={16} /> : <FaEye size={16} />}
                </button>
              </div>
            </div>

            <div className="st-form-group">
              <label className="st-label">New Password</label>
              <input
                type="password"
                className="st-input"
                value={passwordData.new}
                onChange={(e) => setPasswordData({ ...passwordData, new: e.target.value })}
                placeholder="Enter new password"
              />
            </div>

            <div className="st-form-group">
              <label className="st-label">Confirm New Password</label>
              <input
                type="password"
                className="st-input"
                value={passwordData.confirm}
                onChange={(e) => setPasswordData({ ...passwordData, confirm: e.target.value })}
                placeholder="Confirm new password"
              />
            </div>

            <button className="st-save-btn" onClick={updatePassword}>
              <FaSave size={13} /> Update Password
            </button>
          </>
        );

      /* ✅ COMMENTED OUT - Notifications Tab (Future Use)
      case 'notifications':
        return (
          <>
            <h3 className="st-title">Notification Settings</h3>
            <p className="st-subtitle">Manage how you receive notifications</p>

            <Toggle value={notifications.email} 
              onClick={() => setNotifications({ ...notifications, email: !notifications.email })} 
              label="Email Notifications" description="Receive notifications via email" />
            <Toggle value={notifications.push} 
              onClick={() => setNotifications({ ...notifications, push: !notifications.push })} 
              label="Push Notifications" description="Receive notifications in browser" />
            <Toggle value={notifications.sms} 
              onClick={() => setNotifications({ ...notifications, sms: !notifications.sms })} 
              label="SMS Notifications" description="Receive notifications via SMS" />
            <Toggle value={notifications.marketing} 
              onClick={() => setNotifications({ ...notifications, marketing: !notifications.marketing })} 
              label="Marketing Emails" description="Receive promotional emails and offers" />

            <button className="st-save-btn" onClick={saveNotifications}>
              <FaSave size={13} /> Save Preferences
            </button>
          </>
        );
      */

      /* ✅ COMMENTED OUT - Privacy Tab (Future Use)
      case 'privacy':
        return (
          <>
            <h3 className="st-title">Privacy Settings</h3>
            <p className="st-subtitle">Control who can see your information</p>

            <div className="st-form-group">
              <label className="st-label">Profile Visibility</label>
              <select className="st-input" value={privacy.profileVisibility} 
                onChange={(e) => setPrivacy({ ...privacy, profileVisibility: e.target.value })}>
                <option value="public">Public</option>
                <option value="private">Private</option>
                <option value="members">Members Only</option>
              </select>
            </div>

            <Toggle value={privacy.showEmail} 
              onClick={() => setPrivacy({ ...privacy, showEmail: !privacy.showEmail })} 
              label="Show Email" description="Display email on your profile" />
            <Toggle value={privacy.showPhone} 
              onClick={() => setPrivacy({ ...privacy, showPhone: !privacy.showPhone })} 
              label="Show Phone Number" description="Display phone number on your profile" />
            <Toggle value={privacy.showLocation} 
              onClick={() => setPrivacy({ ...privacy, showLocation: !privacy.showLocation })} 
              label="Show Location" description="Display location on your profile" />

            <button className="st-save-btn" onClick={savePrivacy}>
              <FaSave size={13} /> Save Privacy Settings
            </button>
          </>
        );
      */

      /* ✅ COMMENTED OUT - Appearance Tab (Future Use)
      case 'appearance':
        return (
          <>
            <h3 className="st-title">Appearance Settings</h3>
            <p className="st-subtitle">Customize your dashboard appearance</p>

            <Toggle value={darkMode} onClick={() => setDarkMode(!darkMode)} 
              label="Dark Mode" description="Switch to dark theme for better night viewing" />
            <Toggle value={false} onClick={() => { }} 
              label="Compact View" description="Show more content with compact layout" />

            <div className="st-form-group" style={{ marginTop: 16 }}>
              <label className="st-label">Theme Color</label>
              <select className="st-input">
                <option value="pink">💖 Pink (Default)</option>
                <option value="blue">💙 Blue</option>
                <option value="green">💚 Green</option>
                <option value="purple">💜 Purple</option>
              </select>
            </div>

            <button className="st-save-btn">
              <FaSave size={13} /> Save Appearance
            </button>
          </>
        );
      */

      /* ✅ COMMENTED OUT - Language Tab (Future Use)
      case 'language':
        return (
          <>
            <h3 className="st-title">Language Settings</h3>
            <p className="st-subtitle">Choose your preferred language</p>

            <div className="st-form-group">
              <label className="st-label">Display Language</label>
              <select className="st-input">
                <option value="en">🇬🇧 English</option>
                <option value="hi">🇮🇳 Hindi</option>
                <option value="mr">Marathi</option>
                <option value="gu">Gujarati</option>
                <option value="ta">Tamil</option>
                <option value="te">Telugu</option>
                <option value="bn">Bengali</option>
                <option value="ur">Urdu</option>
              </select>
            </div>

            <div className="st-form-group">
              <label className="st-label">Secondary Language</label>
              <select className="st-input">
                <option value="">None</option>
                <option value="hi">Hindi</option>
                <option value="mr">Marathi</option>
                <option value="gu">Gujarati</option>
                <option value="ta">Tamil</option>
              </select>
            </div>

            <button className="st-save-btn">
              <FaSave size={13} /> Save Language
            </button>
          </>
        );
      */

      // ✅ ACTIVE - Support Tab
       case 'support':
        return (
          <>
            <h3 className="st-title">Help & Support</h3>
            <p className="st-subtitle">We're here to help you 💖</p>

            {/* ✅ Quick Contact Cards */}
            <div className="st-contact-cards">
              <a
                href="mailto:communityrishtey@gmail.com"
                className="st-contact-card"
              >
                <div className="st-contact-card-icon email-icon">
                  <FaFileAlt size={20} />
                </div>
                <div>
                  <p className="st-contact-card-title">Email Us</p>
                  <p className="st-contact-card-sub">communityrishtey@gmail.com</p>
                </div>
                <FaChevronRight size={14} className="st-contact-card-arrow" />
              </a>

              <a
                href="tel:+918962813719"
                className="st-contact-card"
              >
                <div className="st-contact-card-icon phone-icon">
                  <FaHeadset size={20} />
                </div>
                <div>
                  <p className="st-contact-card-title">Call Us</p>
                  <p className="st-contact-card-sub">+91-8962813719</p>
                </div>
                <FaChevronRight size={14} className="st-contact-card-arrow" />
              </a>

              <a
                href="https://wa.me/918962813719?text=Hello%20I%20need%20help%20with%20my%20account"
                target="_blank"
                rel="noreferrer"
                className="st-contact-card"
              >
                <div className="st-contact-card-icon whatsapp-icon">
                  {/* WhatsApp icon - react-feather me nahi hai, text use karte hain */}
                  <span style={{ fontSize: 20 }}>💬</span>
                </div>
                <div>
                  <p className="st-contact-card-title">WhatsApp</p>
                  <p className="st-contact-card-sub">Chat with us directly</p>
                </div>
                <FaChevronRight size={14} className="st-contact-card-arrow" />
              </a>
            </div>

            {/* ✅ Quick Links */}
            <h4 className="st-support-section-title">Quick Links</h4>
            <div className="st-support-links">
              <button
                className="st-support-btn"
                onClick={() => navigate('/Term_Use')}
              >
                <span style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <div className="st-support-icon"><FaFileAlt /></div>
                  <span>Terms & Conditions</span>
                </span>
                <FaChevronRight size={14} />
              </button>

              <button
                className="st-support-btn"
                onClick={() => navigate('/Privacy_Policy')}
              >
                <span style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <div className="st-support-icon"><FaShieldAlt /></div>
                  <span>Privacy Policy</span>
                </span>
                <FaChevronRight size={14} />
              </button>

              <button
                className="st-support-btn"
                onClick={() => navigate('/Froud_Alert')}
              >
                <span style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <div className="st-support-icon"><FaQuestionCircle /></div>
                  <span>Fraud Alert</span>
                </span>
                <FaChevronRight size={14} />
              </button>

              <button
                className="st-support-btn"
                onClick={() => navigate('/contact')}
              >
                <span style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <div className="st-support-icon"><FaHeadset /></div>
                  <span>Contact Support</span>
                </span>
                <FaChevronRight size={14} />
              </button>
            </div>

            {/* ✅ FAQ Section */}
            <h4 className="st-support-section-title" style={{ marginTop: 24 }}>
              Frequently Asked Questions
            </h4>
            <div className="st-faq-list">
              {faqData.map((faq) => (
                <div
                  key={faq.id}
                  className={`st-faq-item ${openFaq === faq.id ? 'open' : ''}`}
                >
                  <button
                    className="st-faq-question"
                    onClick={() => setOpenFaq(openFaq === faq.id ? null : faq.id)}
                  >
                    <span>{faq.question}</span>
                    <FaChevronDown
                      size={14}
                      className={`st-faq-arrow ${openFaq === faq.id ? 'rotated' : ''}`}
                    />
                  </button>
                  {openFaq === faq.id && (
                    <div className="st-faq-answer">
                      <p>{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </>
        );

      // ✅ ACTIVE - Logout Tab
      case 'logout':
        return (
          <>
            <h3 className="st-title">Logout</h3>
            <p className="st-subtitle">Are you sure you want to logout?</p>

            <div className="st-logout-box">
              <h4 className="st-logout-title"><FaSignOutAlt /> Logout from Account</h4>
              <p className="st-logout-desc">
                You will be redirected to the login page. You can always log back in.
              </p>
              <button
                className="st-logout-btn"
                onClick={() => {
                  localStorage.removeItem('user_id');
                  localStorage.removeItem('user_role');
                  localStorage.removeItem('user_token');
                  localStorage.removeItem('access_token');
                  localStorage.removeItem('user_gender');
                  localStorage.removeItem('user_caste');
                  localStorage.removeItem('token');
                  window.location.href = '/User_Login';
                }}
              >
                <FaSignOutAlt size={13} /> Logout Now
              </button>
            </div>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <>
       <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&display=swap');
        * { font-family: 'Poppins', sans-serif !important; box-sizing: border-box; margin: 0; }

        .st-page { background: #fff; min-height: 100vh; padding: 20px 16px; }
        .st-wrap { max-width: 1280px; margin: 0 auto; }

        /* Header */
        .st-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 22px; flex-wrap: wrap; gap: 12px; }
        .st-page-title { font-size: 24px; font-weight: 800; color: #1a0a10; margin: 0; display: flex; align-items: center; gap: 10px; }
        .st-page-title svg { color: #ff0055; }
        .st-page-sub { color: #888; font-size: 13.5px; margin: 4px 0 0; }

        /* Layout */
        .st-layout { display: flex; gap: 22px; flex-wrap: wrap; }

        /* Sidebar */
        .st-sidebar { width: 250px; flex-shrink: 0; background: #fff; border: 2px solid #ffe4ec; border-radius: 18px; padding: 10px; box-shadow: 0 6px 20px rgba(255,0,85,.05); height: fit-content; }
        .st-sidebar-item { display: flex; align-items: center; gap: 12px; padding: 12px 16px; border: none; background: transparent; cursor: pointer; width: 100%; font-size: 13.5px; color: #666; font-weight: 600; transition: all .25s ease; text-align: left; border-radius: 12px; margin-bottom: 3px; }
        .st-sidebar-item:hover { background: #fff0f3; color: #ff0055; }
        .st-sidebar-item.active { background: linear-gradient(135deg, #ff0055, #ff4d88); color: #fff; box-shadow: 0 6px 16px rgba(255,0,85,.2); }
        .st-sidebar-item.active svg { color: #fff !important; }
        .st-sidebar-icon { font-size: 16px; color: #ff4d88; flex-shrink: 0; }
        .st-sidebar-label { flex: 1; }
        .st-sidebar-badge { background: #ff0055; color: #fff; font-size: 10.5px; padding: 2px 8px; border-radius: 999px; font-weight: 700; }
        .st-sidebar-item.active .st-sidebar-badge { background: rgba(255,255,255,.25); color: #fff; }

        /* Content */
        .st-content { flex: 1; min-width: 300px; background: #fff; border: 2px solid #ffe4ec; border-radius: 18px; padding: 26px; box-shadow: 0 6px 20px rgba(255,0,85,.05); }
        .st-title { font-size: 20px; font-weight: 800; color: #1a0a10; margin: 0 0 4px; }
        .st-subtitle { font-size: 13.5px; color: #888; margin: 0 0 22px; }

        /* Form */
        .st-form-group { margin-bottom: 18px; }
        .st-label { display: block; font-size: 12.5px; font-weight: 700; color: #c2185b; margin-bottom: 6px; text-transform: uppercase; letter-spacing: .3px; }
        .st-input { width: 100%; padding: 11px 14px; border: 1.5px solid #ffe4ec; border-radius: 12px; font-size: 13.5px; outline: none; transition: all .3s ease; background: #fff; color: #1a0a10; font-family: 'Poppins', sans-serif; }
        .st-input:focus { border-color: #ff0055; box-shadow: 0 0 0 3px rgba(255,0,85,.08); }
        .st-input:hover { border-color: #ffb3c8; }

        /* Eye toggle */
        .st-eye-btn { position: absolute; right: 12px; top: 50%; transform: translateY(-50%); background: none; border: none; cursor: pointer; color: #ff4d88; display: flex; align-items: center; justify-content: center; }
        .st-eye-btn:hover { color: #ff0055; }

        /* Save button */
        .st-save-btn { padding: 12px 28px; background: linear-gradient(135deg, #ff0055, #ff4d88); color: #fff; border: none; border-radius: 999px; font-size: 13.5px; font-weight: 700; cursor: pointer; display: inline-flex; align-items: center; gap: 8px; box-shadow: 0 8px 22px rgba(255,0,85,.22); transition: all .3s ease; margin-top: 14px; }
        .st-save-btn:hover { transform: translateY(-2px); box-shadow: 0 12px 28px rgba(255,0,85,.3); }

        /* ✅ Contact Cards */
        .st-contact-cards { display: flex; flex-direction: column; gap: 10px; margin-bottom: 24px; }
        .st-contact-card { display: flex; align-items: center; gap: 14px; padding: 14px 16px; background: linear-gradient(135deg, #fffafc, #fff0f3); border: 1.5px solid #ffe4ec; border-radius: 14px; text-decoration: none; color: #1a0a10; transition: all .25s ease; cursor: pointer; }
        .st-contact-card:hover { background: linear-gradient(135deg, #fff0f3, #ffe4ec); border-color: #ffb3c8; transform: translateX(4px); box-shadow: 0 6px 18px rgba(255,0,85,.08); }
        .st-contact-card-icon { width: 44px; height: 44px; border-radius: 12px; display: flex; align-items: center; justify-content: center; color: #fff; flex-shrink: 0; }
        .email-icon { background: linear-gradient(135deg, #ff0055, #ff4d88); }
        .phone-icon { background: linear-gradient(135deg, #4caf50, #81c784); }
        .whatsapp-icon { background: linear-gradient(135deg, #25D366, #128C7E); }
        .st-contact-card-title { font-size: 14px; font-weight: 700; color: #1a0a10; margin: 0 0 2px; }
        .st-contact-card-sub { font-size: 12px; color: #888; margin: 0; }
        .st-contact-card-arrow { color: #ff0055; margin-left: auto; flex-shrink: 0; }
        .st-contact-card > div:nth-child(2) { flex: 1; }

        /* ✅ Support Section Title */
        .st-support-section-title { font-size: 15px; font-weight: 700; color: #1a0a10; margin: 0 0 12px; padding-bottom: 8px; border-bottom: 1.5px solid #fff0f3; }

        /* ✅ Support Links */
        .st-support-links { display: flex; flex-direction: column; gap: 8px; }
        .st-support-btn { display: flex; align-items: center; justify-content: space-between; padding: 13px 16px; background: linear-gradient(135deg, #fffafc, #fff0f3); border: 1.5px solid #ffe4ec; border-radius: 12px; cursor: pointer; transition: all .25s ease; width: 100%; text-align: left; font-size: 13.5px; font-weight: 600; color: #1a0a10; }
        .st-support-btn:hover { background: linear-gradient(135deg, #fff0f3, #ffe4ec); border-color: #ffb3c8; transform: translateY(-2px); box-shadow: 0 6px 18px rgba(255,0,85,.08); }
        .st-support-btn svg { color: #ff0055; }
        .st-support-icon { width: 34px; height: 34px; border-radius: 10px; background: linear-gradient(135deg, #ff0055, #ff4d88); color: #fff; display: flex; align-items: center; justify-content: center; font-size: 15px; flex-shrink: 0; }

        /* ✅ FAQ List */
        .st-faq-list { display: flex; flex-direction: column; gap: 8px; }
        .st-faq-item { border: 1.5px solid #ffe4ec; border-radius: 12px; overflow: hidden; transition: all .25s ease; }
        .st-faq-item.open { border-color: #ff0055; box-shadow: 0 4px 16px rgba(255,0,85,.08); }
        .st-faq-question { display: flex; align-items: center; justify-content: space-between; width: 100%; padding: 14px 16px; background: linear-gradient(135deg, #fffafc, #fff5f7); border: none; cursor: pointer; text-align: left; font-size: 13.5px; font-weight: 600; color: #1a0a10; gap: 12px; transition: all .25s ease; }
        .st-faq-item.open .st-faq-question { background: linear-gradient(135deg, #fff0f3, #ffe4ec); color: #ff0055; }
        .st-faq-question:hover { background: linear-gradient(135deg, #fff0f3, #ffe4ec); }
        .st-faq-arrow { color: #ff0055; flex-shrink: 0; transition: transform .3s ease; }
        .st-faq-arrow.rotated { transform: rotate(180deg); }
        .st-faq-answer { padding: 12px 16px 14px; background: #fff; border-top: 1.5px solid #ffe4ec; }
        .st-faq-answer p { font-size: 13px; color: #555; line-height: 1.7; margin: 0; }

        /* Logout box */
        .st-logout-box { margin-top: 20px; padding: 22px; border: 2px solid #ffd3df; border-radius: 16px; background: linear-gradient(135deg, #fff0f3, #ffe4ec); }
        .st-logout-title { font-size: 17px; font-weight: 800; color: #ff0055; margin: 0 0 6px; display: flex; align-items: center; gap: 8px; }
        .st-logout-desc { font-size: 13.5px; color: #555; margin: 0 0 16px; }
        .st-logout-btn { padding: 11px 24px; border: none; border-radius: 999px; background: linear-gradient(135deg, #ff0055, #ff4d88); color: #fff; font-size: 13px; font-weight: 700; cursor: pointer; display: inline-flex; align-items: center; gap: 7px; box-shadow: 0 8px 22px rgba(255,0,85,.22); transition: all .3s ease; }
        .st-logout-btn:hover { transform: translateY(-2px); box-shadow: 0 12px 28px rgba(255,0,85,.3); }

        /* Responsive */
        @media (max-width: 1024px) {
          .st-layout { flex-direction: column; }
          .st-sidebar { width: 100%; display: flex; flex-wrap: wrap; padding: 6px; gap: 4px; }
          .st-sidebar-item { flex: 1; min-width: 100px; justify-content: center; padding: 10px 12px; margin-bottom: 0; font-size: 12px; }
        }
        @media (max-width: 768px) {
          .st-content { padding: 20px 16px; }
          .st-contact-card { padding: 12px 14px; }
          .st-contact-card-icon { width: 38px; height: 38px; border-radius: 10px; }
          .st-contact-card-title { font-size: 13px; }
          .st-contact-card-sub { font-size: 11px; }
          .st-faq-question { font-size: 13px; padding: 12px 14px; }
          .st-faq-answer { padding: 10px 14px 12px; }
          .st-faq-answer p { font-size: 12px; }
        }
        @media (max-width: 480px) {
          .st-save-btn { width: 100%; justify-content: center; }
          .st-sidebar-badge { display: none; }
          .st-contact-card-sub { display: none; }
        }
      `}</style>

      <div className="st-page">
        <div className="st-wrap">

          {/* Header */}
          <div className="st-header">
            <div>
              <h1 className="st-page-title">
                <FaUserCog /> Settings
              </h1>
              <p className="st-page-sub">Manage your account settings and preferences 💖</p>
            </div>
          </div>

          {/* Layout */}
          <div className="st-layout">

            {/* Sidebar - Only 3 items now */}
            <div className="st-sidebar">
              {sidebarItems.map((item) => {
                const Icon = item.icon;
                return (
                  <button
                    key={item.id}
                    className={`st-sidebar-item ${activeTab === item.id ? 'active' : ''}`}
                    onClick={() => setActiveTab(item.id)}
                  >
                    <Icon className="st-sidebar-icon" />
                    <span className="st-sidebar-label">{item.label}</span>
                    {item.badge && <span className="st-sidebar-badge">{item.badge}</span>}
                  </button>
                );
              })}
            </div>

            {/* Content */}
            <div className="st-content">
              {renderContent()}
            </div>

          </div>

        </div>
      </div>
    </>
  );
};

export default Settings;